import Switch from '@components/v2/form/Switch/Switch';
import LangEnum from '../../../../lang/LangEnum';
import { isAdminTeceo } from '../../../context/ApplicationContext/applicationContext.utils';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { PaymentMethodSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const PaymentMethodSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: PaymentMethodSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_PAYMENT_METHOD)}
      description={LangEnum.GENERAL_SETTINGS_PAYMENT_METHOD_SECTION_DESCRIPTION}
    >
      <Switch
        label={translate(LangEnum.GENERAL_SETTINGS_SHOW_PAYMENT_METHOD_ACCUMULATED_INTEREST)}
        name="showPaymentMethodsAccumulatedInterest"
        size="medium"
        sx={{ ml: 0 }}
        disabled={!isAdminTeceo()}
        checked={generalSettings.showPaymentMethodsAccumulatedInterest}
        onChange={(_, checked) =>
          handleChangeAndBlur({ value: checked, name: 'showPaymentMethodsAccumulatedInterest' })
        }
      />
    </SettingContainer>
  );
};

export default PaymentMethodSectionGeneralSettings;
